import { Laptop, HeartPulse, Check, ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/scrollTo";
import { Reveal, SectionTag } from "@/components/doodles";

const IMG = {
  two: "https://images.unsplash.com/photo-1682531492775-e5e8067caae3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format&fit=crop",
  three: "https://images.unsplash.com/photo-1593431763017-c689a61b729a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format&fit=crop",
};

const SERVICES = [
  {
    icon: Laptop,
    img: IMG.two,
    alt: "Online coaching program on a phone",
    badge: "TRAIN ANYWHERE",
    badgeColor: "bg-electric",
    title: "HYBRID ONLINE COACHING",
    copy: "Full programming in an app, video form feedback, and real check-ins. Never train alone.",
    features: ["Weekly programming in your pocket", "Video form reviews", "Direct text access to your coach"],
  },
  {
    icon: HeartPulse,
    img: IMG.three,
    alt: "Athlete rebuilding mobility on a mat",
    badge: "MY SPECIALTY",
    badgeColor: "bg-lime",
    title: "THE REBUILD",
    copy: "Coming back from injury or a long break? A gentle-but-focused bridge back to the training you love.",
    features: ["Return-to-sport progressions", "Mobility + capacity building", "Patience, built right in"],
  },
];

export const Services = () => (
  <section id="services" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <Reveal><SectionTag className="text-pink">COACHING SERVICES</SectionTag></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3 leading-[0.95]">
              COACHING THAT FITS <span className="text-stroke">YOUR LIFE</span>.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="font-hand text-2xl sm:text-3xl text-royal rotate-1">every plan starts with a free intro call</p>
        </Reveal>
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-testid="services-grid">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08} className="h-full">
            <div className="card-pop h-full bg-white flex flex-col" data-testid={`service-card-${i + 1}`}>
              <div className="relative h-44 border-b-[3px] border-ink overflow-hidden">
                <img src={s.img} alt={s.alt} loading="lazy" className="w-full h-full object-cover" />
                <span className={`absolute top-3 left-3 ${s.badgeColor} border-[2.5px] border-ink font-bebas tracking-[0.2em] text-xs px-2.5 py-1 shadow-[3px_3px_0_#0d0d0d] -rotate-2`}>
                  {s.badge}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 border-[3px] border-ink flex items-center justify-center shadow-[3px_3px_0_#0d0d0d] bg-offwhite">
                    <s.icon className="w-5 h-5" />
                  </span>
                  <h3 className="font-display font-extrabold uppercase text-2xl leading-none">{s.title}</h3>
                </div>
                <p className="mt-4 text-sm font-semibold text-ink/70 leading-relaxed">{s.copy}</p>
                <ul className="mt-4 space-y-2 flex-1">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm font-semibold text-ink/80">
                      <span className="mt-0.5 w-4 h-4 shrink-0 bg-lime border-2 border-ink flex items-center justify-center">
                        <Check className="w-3 h-3" strokeWidth={4} />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => scrollToId("contact")}
                  data-testid={`service-cta-${i + 1}`}
                  className="btn-pop bg-ink text-cream w-full px-5 py-3.5 mt-6 text-sm"
                >
                  Book a free intro call <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
